import React from "react";
import { styled } from "@mui/material/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
} from "@mui/material";

const OutputTitle = styled("Typography")({
  fontSize: "20px",
  fontFamily: "DiodrumSemiBold",
  textAlign: "left",
  paddingBottom : "20px"
});

//table container style
const TableContainer_ = styled(TableContainer)({
  width: '50%',
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  borderRadius: "0px",
  marginTop: "10px",
  borderWidth: "1px",
  marginBottom: "10px",
});
const StyledTableRow = styled(TableRow)({
  backgroundColor: "#F8F8F8",
});

const StyledTableCellHeader = styled(TableCell)({
  fontFamily: "DiodrumSemiBold",
  fontSize: "16px",
  width: "40%",
});

//table cell style
const StyledTableCell = styled(TableCell)({
  fontFamily: "DiodrumRegular",
  fontSize: "12px",
  //reduce top and bottom padding
  paddingTop: "10px",
  height:'30px',
  textAlign: "center",
  width: "20%",
  paddingBottom: "10px",
  //table row index is last
});

const StyledTableCellLabel = styled(TableCell)({
  textAlign: "left",
  fontFamily: "DiodrumRegular",
  width: "80%",
});

const StyledTableCellBold = styled(TableCell)({
  fontFamily: "DiodrumSemiBold",
  fontSize: "12px",
  
  
});

const OutputTable = ({ title,tableHeaders = ["", "", ""] ,data }) => {
  
  return (
    <Box m={3} textAlign={"left"}>
      <OutputTitle>{title}</OutputTitle>
      <TableContainer_ component={Paper}>
        <Table>
          <TableHead>
            <StyledTableRow>
              <TableCell></TableCell>
              
                <StyledTableCellHeader  align="right">{tableHeaders[1]}</StyledTableCellHeader>
                <StyledTableCellHeader  align="right">{tableHeaders[2]}</StyledTableCellHeader>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => {
              //table row index is last set bold font
              const isLast = index !== data.length - 1;
                return (
              <TableRow key={index}>
                <>
                  {isLast ? (
                    <>
                      <StyledTableCellLabel component="th" scope="row">
                        {row.label}
                      </StyledTableCellLabel>
                      <StyledTableCell align="right">
                        {row.value}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {row.value1}
                      </StyledTableCell>
                    </>
                  ) : (
                    <>
                    <StyledTableCellBold
                      component="th"
                      scope="row"
                      align="left"
                      >

                      {row.label}
                    </StyledTableCellBold>
                    <StyledTableCellBold align="center">
                      {row.value}
                    </StyledTableCellBold>
                    <StyledTableCellBold align="center">
                      
                      {row.value1}
                    </StyledTableCellBold>
                  </>
                  )}
                </>
              </TableRow>
                )
            
            })}
          </TableBody>
        </Table>
      </TableContainer_>
    </Box>
  );
};

export default OutputTable;
